import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AccountType, PaymentMethodType, PaymentModelClient, PaymentModelDatabase} from '../model/payments.model';
import {Observable} from "rxjs";
import {CurrentContextService} from '../../../core/services/security/current-context.service';
import {BaseService} from '../../../core/services/base.service';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RetailerPaymentMethodsService extends BaseService {


  baseUrl = environment.apiRetailersHost;
  private currentPaymentMethod: PaymentModelClient | null = null;

  constructor(private http: HttpClient, private context: CurrentContextService) {
    super();
  }

  updatePaymentMethod(paymentMethod: PaymentModelClient): void {
    this.currentPaymentMethod = paymentMethod;
  }

  initPaymentMethod(paymentMethod: PaymentModelClient): void {
    this.currentPaymentMethod = paymentMethod;
  }

  getMethod(): PaymentModelClient {
    return this.currentPaymentMethod!;
  }

  getTitle(): string {
    if (this.currentPaymentMethod?.uuid) {
      return ('Update');
    }
    return 'Add';
  }

  public areValuesNull(): boolean {
    return this.currentPaymentMethod === undefined || this.currentPaymentMethod === null;
  }

  getBankAccountTypes(): AccountType[] {
    return [
      {code: '1', type: 'Cheque'},
      {code: '2', type: 'Saving'}
    ];
  }

  createOtpRequest(): Observable<any> {
    const retailerId = this.context.getCurrentRetailer().id;
    let uri = this.baseUrl + `/portal/retailer/${retailerId}/payment-methods/`;
    uri = uri + (this.currentPaymentMethod?.uuid ? 'update-request' : 'create-request');
    return this.http.get<any>(uri);
  }

  paymentMethodOtpConfirm(otp: string): Observable<PaymentModelDatabase> {
    const retailerId = this.context.getCurrentRetailer().id;
    let uri = this.baseUrl + `/portal/retailer/${retailerId}/payment-methods/`;
    uri = uri + (this.currentPaymentMethod?.uuid ? `update-confirm/${otp}` : `create-confirm/${otp}`);
    return this.http.post<PaymentModelDatabase>(uri, this.currentPaymentMethod);
  }

  public getAll(): Observable<PaymentModelDatabase[]> {
    const retailerId = this.context.getCurrentRetailer().id;
    const uri = this.baseUrl + `/portal/retailer/${retailerId}/payment-methods/get-all`;
    return this.http.get<PaymentModelDatabase[]>(uri);
    /*return new Promise((resolve, reject) => {
      this.http.get<any>(uri).subscribe((res) => {
        resolve(res);
      }, err => {
        reject(err);
      });
    });*/
  }

  public deletePaymentMethod(uuid: string): Observable<Object> {
    const retailerId = this.context.getCurrentRetailer().id;
    const uri = this.baseUrl + `/portal/retailer/${retailerId}/payment-methods/${uuid}`;
    return this.http.delete(uri);
  }

  public getTypeNameFromCode(code: string): string {
    code = code.replace('_', ' ');
    code = code.toLowerCase();
    code = code.substring(0, 1).toUpperCase() + code.substring(1, code.length);
    return code;
  }

  public getAllOptions(): Observable<PaymentMethodType[]> {
    const retailerId = this.context.getCurrentRetailer().id;
    const uri = this.baseUrl + `/portal/retailer/${retailerId}/payment-methods/options`;
    return this.http.get<PaymentMethodType[]>(uri);
  }

  /*
    public getOneUserById(userId: number): Observable<User> {
      const uri = environment.apiSecurityHost + `/api/user/${userId}`;
      return this.http.get<any>(uri);
    }*/
}
